import React from "react";
import { Tag } from "antd";
export default function InternalTag() {
    return (React.createElement(Tag, { color: "blue", style: { display: "table" } }, "Internal"));
}
